// Keep in sync with express_app/constants/ollieLimits.js
export const OLLIE_PLAN_LIMITS = {
  freeMonthly: 20,
  freeDaily: 5,
  paidMonthly: 200,
}

export function getOllieFeatureGroup(plan) {
  const isFree = plan === 'Free'

  return {
    title: 'Ollie',
    features: isFree
      ? [
          // Included Free allowances — ticks, not locks.
          `${OLLIE_PLAN_LIMITS.freeMonthly} Ollie questions/month`,
          `${OLLIE_PLAN_LIMITS.freeDaily} questions/day`,
          'Get help learning OMS across the platform',
        ]
      : [
          `${OLLIE_PLAN_LIMITS.paidMonthly} Ollie questions/month`,
          'No daily question cap',
          'Get help learning OMS across the platform',
        ],
  }
}
